import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { reduxActions, RootState } from '../../../store';

import { IAoo, IUor } from '../../../shared/interfaces';
import usersService from '../../../services/users.service';

const queryString = require('query-string');

const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentUor: state.sessionReducer.currentUor,
    currentAoo: state.sessionReducer.currentAoo,
    userActiveAoo: state.sessionReducer.userActiveAoo,
    organigrammaFlat: state.sessionReducer.organigrammaFlat
})
const mapDispatch = {
    updateSession: (session) => (reduxActions.sessionActions.updateSession(session)),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>


export interface RoutingManagerProps {
}
export interface RoutingManagerState {
    aooId: number | undefined
    uorId?: number
}
type Props = RoutingManagerProps & RouteComponentProps & PropsFromRedux



class RoutingManager extends React.Component<Props, RoutingManagerState> {

    state: RoutingManagerState = {
        aooId: undefined,
        uorId: undefined,
    }
    componentDidMount() {
        const { location } = this.props;
        const parsedQueryString = queryString.parse(location.search);

        this.setState({
            aooId: Number(this.props.match.params["aooId"]),
            uorId: Number(parsedQueryString.uorId),
        });
    }

    componentDidUpdate(oldProps: Props, oldState: RoutingManagerState) {
        const { location, history, updateSession, currentAoo, currentUor, currentUser, userActiveAoo, organigrammaFlat } = this.props;
        const parsedQueryString = queryString.parse(location.search);

        if (Number(this.props.match.params["aooId"]) && this.state.aooId !== Number(this.props.match.params["aooId"])) {
            this.setState({
                aooId: Number(this.props.match.params["aooId"]),
            });

            return;
        }


        let newUorId: number | undefined;
        if (Number(parsedQueryString.uorId)) {
            newUorId = Number(parsedQueryString.uorId);
        }

        if (this.state.uorId != newUorId) {
            this.setState({
                uorId: newUorId
            });
            return;

        }


        if (currentUser && userActiveAoo) {


            // se NON ho aooId nell'url prendo quello della default AOO, se non c'è una AOO di default prendo la prima Aoo tra quelle attive dell'utente
            if (!this.state.aooId) {

                let aoo: IAoo | undefined;
                if (currentUser.defaultAooId) {
                    aoo = userActiveAoo.find(el => el.id === currentUser.defaultAooId);
                }
                else {

                    aoo = userActiveAoo.length > 0 ? userActiveAoo[0] : undefined;
                }

                if (aoo) {
                    history.push({ pathname: `/${aoo.id}/ricerca` });
                    updateSession({ currentUor: undefined, currentAoo: undefined });

                }
                else {
                    updateSession({ currentUor: undefined, currentAoo: undefined });
                    history.push({ pathname: '/unauthorized' });
                }

            }
            /// se cambio l'aoo non devo fare nulla (c'è una redirect che ricarica l'app)
            /// l'if serve solo per evitare di fare il check degli altri else
            else if (oldState.aooId && oldState.aooId !== this.state.aooId) {
            }
            // ho aooId ma non ho aggiornato currentAoo
            else if (this.state.aooId && (!currentAoo || this.state.aooId !== currentAoo.id)) {

                let aoo = userActiveAoo.find(el => el.id === this.state.aooId);
                if (aoo) {
                    //sessionStorage.setItem('aoo', JSON.stringify(aoo));
                    updateSession({ currentAoo: aoo });
                    //history.push({ pathname: `/${aoo.id}/ricerca` });
                }
                else {
                    //sessionStorage.removeItem('aoo');
                    delete parsedQueryString.uorId;
                    const newQueryString = queryString.stringify(parsedQueryString);
                    updateSession({ currentUor: undefined, currentAoo: undefined });
                    history.push({ pathname: '/notfound', search: newQueryString });
                }
            }
            // se non ho uorId nell'url setto currentUor undefined
            else if (currentAoo && !this.state.uorId) {
                updateSession({ currentUor: undefined });

            }
            // ho uorId ma non ho aggiornato currentUor oppure cambio uor
            else if (currentAoo && organigrammaFlat && ((this.state.uorId && !currentUor) || (!Number.isNaN(this.state.uorId) && oldState.uorId !== this.state.uorId))) {
                // ricavo le uor in cui l'utente corrente ha almeno un ruolo 
                const uorIdWhereUserHasAnyUorContextRole = currentUser?.ruoliUorContext.reduce((a: number[], o) => (o.aooId === currentAoo?.id && a.push(o.uorId), a), []) ?? [];
                const uorIndexInOrganigrammaFlat = organigrammaFlat.findIndex(el => el.aooId === currentAoo.id && el.id === this.state.uorId);

                let userHasAnyUorContextRoleInCurrentUor = uorIdWhereUserHasAnyUorContextRole.some(el => el === this.state.uorId);
                if (!userHasAnyUorContextRoleInCurrentUor && usersService.userDTOIsSupervisore(currentUser, currentAoo.id)) {

                    if (uorIndexInOrganigrammaFlat < 0) {
                        updateSession({ currentUor: undefined });
                    }
                    else {
                        updateSession({ currentUor: organigrammaFlat[uorIndexInOrganigrammaFlat] });

                    }
                }
                else if (!userHasAnyUorContextRoleInCurrentUor) {
                    delete parsedQueryString.uorId;
                    const newQueryString = queryString.stringify(parsedQueryString);

                    updateSession({ currentUor: undefined, currentAoo: undefined });
                    history.push({ pathname: '/notfound', search: newQueryString });
                }
                else {
                    updateSession({ currentUor: organigrammaFlat[uorIndexInOrganigrammaFlat] });

                }

            }
        }
    }

    render() {
        return (
            <span></span >
        );
    };
}
export default connector(withRouter(RoutingManager));
